import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const ChangeCurrentUserPassword: React.FC<IChangeCurrentUserPassword> = ({
  onSubmit,
  onClose,
}) => {
  const form = useForm()
  const { addAlert } = useSnackBars()

  const submit = (values) => {
    if (values.newPassword !== values.confirmNewPassword) {
      addAlert({
        message: 'Las contraseñas deben de coincidir.',
        status: 'error',
      })
      return
    }
    onSubmit(values)
  }

  return (
    <>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Cambiar contraseña
      </h2>

      <Form form={form} onSubmit={submit} classes="gap-x-6">
        <FormItem
          name="currentPassword"
          classes="col-span-12 mt-5"
          rules={{ required: 'Es necesario ingresar este campo' }}
        >
          <InputText label="Contraseña actual" password />
        </FormItem>

        <FormItem
          name="newPassword"
          classes="col-span-12 mt-5"
          rules={{ required: 'Es necesario ingresar este campo' }}
        >
          <InputText label="Nueva contraseña" password />
        </FormItem>

        <FormItem
          name="confirmNewPassword"
          classes="col-span-12 mt-5"
          rules={{ required: 'Es necesario ingresar este campo' }}
        >
          <InputText label="Confirmar nueva contraseña" password />
        </FormItem>

        <div className="col-start-4 col-span-9 flex space-x-2 mt-4 px-1 mt-10 row-start-8 block lg:col-start-3">
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
          <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
            Guardar cambios
          </Button>
        </div>
      </Form>
    </>
  )
}

export default ChangeCurrentUserPassword

interface IChangeCurrentUserPassword {
  onSubmit: (values: any) => void
  onClose: () => void
}
